import { Text } from 'wix-style-react';
import * as React from 'react';
export var BillingAddress = function (_a) {
    var billingAddressLocalizedLocation = _a.billingAddressLocalizedLocation, addressLocalizedLocation = _a.addressLocalizedLocation;
    return (React.createElement(Text, { size: "tiny", secondary: true, dataHook: "customer-billing-address" }, billingAddressLocalizedLocation || addressLocalizedLocation));
};
//# sourceMappingURL=BillingAddress.js.map